import React from 'react';
import axios from 'axios';
import { render, screen, act, fireEvent } from '@testing-library/react';
import '@testing-library/jest-dom';
import PatientImages from './patient_images';

jest.mock('axios');

describe('PatientImages', () => {
  test('change text on click', async () => {
    const promise = Promise.resolve({ data: [{ m_patient_id: 1,
      m_institution_id: 2,
      avator_flg: true,
      personal_info_flg: true,
      s3_object_name: "s3_object_name",
      s3_object_public_url: "s3_object_public_url" }] });

    (axios.get as any).mockResolvedValue(promise);
    render(<PatientImages can_edit_setting={true} />);

    await act(() => promise);
    fireEvent.click(screen.getByText('アバターを取り消す'));
    fireEvent.click(screen.getByText('削除保護を取り消す'));
    fireEvent.click(screen.getByText('削除する'));

    // screen.debug();

    expect(screen.getByText('アバターに設定')).toBeInTheDocument();
    expect(screen.getByText('削除保護')).toBeInTheDocument();
    expect(screen.getByText('削除を取り消す')).toBeInTheDocument();
  });
});
